import { Hosts } from '~helpers/environments';

const defaultStorage = 'local';

export function getItem(itemKey, storageType = defaultStorage) {
  if (typeof window === 'undefined') {
    return false;
  }

  const storage = getStorage(storageType);
  const item = storage.getItem(Hosts.prefix + itemKey);

  try {
    return JSON.parse(item);
  } catch (e) {
    return item;
  }
}

export function setItem(itemKey, value, storageType = defaultStorage) {
  if (typeof window === 'undefined') {
    return false;
  }

  const storage = getStorage(storageType);

  if (typeof value === 'object') {
    storage.setItem(Hosts.prefix + itemKey, JSON.stringify(value));
  } else {
    storage.setItem(Hosts.prefix + itemKey, value);
  }

  return true;
}

export function removeItem(itemKey, storageType = defaultStorage) {
  if (typeof window === 'undefined') {
    return false;
  }

  const storage = getStorage(storageType);

  try {
    storage.removeItem(Hosts.prefix + itemKey);
    return true;
  } catch (e) {
    return false;
  }
}

function getStorage(storageType) {
  return storageType === 'local' ? localStorage : sessionStorage;
}

export default {
  getItem,
  setItem,
  removeItem,
};
